<template>
    <div>
        <Main title="Cohorts" subtitle="Management">
            <template v-slot:buttons>
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Create">
                    <a @click="createNewCohort()" class="btn btn-success ml-1 text-white" data-toggle="tooltip" title="Create New Cohort"><i class="fas fa-plus-circle"></i> Create</a>
                </div><!--btn-toolbar-->
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Actions">
                    <a @click="cohortActions()" class="btn btn-info ml-1 text-white" data-toggle="tooltip" title="Cohort Actions"><i class="fas fa-ellipsis-v"></i> Actions</a>
                </div><!--btn-toolbar-->
            </template>

            <template v-slot:table>
                <v-app>
                    <div class="row">
                        <div class="col-md-4 col-8">
                            <div class="input-group">
                                <v-text-field
                                    v-model="searchData.q"
                                    clearable
                                    clear-icon="mdi-close"
                                    type="text"
                                    placeholder="Search by cohort name or ID"
                                >
                                </v-text-field>
                            </div>
                        </div>
                        <div class="offset-md-7 offset-3 col-1">
                            <div class="btn-toolbar float-right" role="toolbar">
                                <button class="btn btn-light" type="button" data-toggle="modal" data-target=".filter-modal"><i class="fas fa-filter"></i></button>
                            </div><!--btn-toolbar-->
                        </div><!--col-->
                    </div>
                    <div class="modal fade filter-modal" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Sort Cohorts</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <v-row class="mt-2">
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="searchData.sortBy"
                                                :items="sorts"
                                                label="Sort By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="searchData.orderBy"
                                                :items="orders"
                                                label="Order By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="searchData.itemsPerPage"
                                                :items="perPage"
                                                label="Per Page"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="modal-footer">
                                    <div class="col-md-2 col-2 px-0 text-right">
                                        <v-progress-circular
                                            v-if="searchData.loading"
                                            :width="2"
                                            :size="30"
                                            indeterminate
                                            color="#fb7e42"
                                            class="mr-2"
                                        ></v-progress-circular>
                                        <button type="button" class="btn btn-light" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <TableLoading cols="11" v-if="loading"></TableLoading>

                    <div class="table-responsive mt-4" v-if="!loading">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">ID</span>
                                        </template>
                                        <span>Cohort Identifier</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Name</span>
                                        </template>
                                        <span>Cohort Name</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Analytics</span>
                                        </template>
                                        <span>Total EIDs, IPs and HEMs</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Status</span>
                                        </template>
                                        <span>Status</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Details</span>
                                        </template>
                                        <span>Details</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Created By</span>
                                        </template>
                                        <span>Cohort Created By</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Updated At</span>
                                        </template>
                                        <span>Updated At</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Created At</span>
                                        </template>
                                        <span>Created At</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Actions</span>
                                        </template>
                                        <span>Actions</span>
                                    </v-tooltip>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <TableLoading v-if="loading"></TableLoading>
                            <tr v-for="cohort in cohorts" :key="cohort.id" class="activation-row" v-if="cohorts">
                                <td>{{ cohort.id }}</td>
                                <td v-if="editing_cohort.id === cohort.id">
                                    <div class="d-flex justify-content-between">
                                        <v-text-field
                                            dense
                                            class="my-0 py-0"
                                            v-model="editing_cohort.name"
                                        ></v-text-field>
                                        <i @click="updateCohortName(cohort.name)" class="fas fa-check ml-2 pt-2 text-success" role="button"></i>
                                        <i @click="cancelUpdateCohortName()" class="fas fa-times ml-2 pt-2 text-danger" role="button"></i>
                                    </div>
                                </td>
                                <td v-if="editing_cohort.id !== cohort.id">
                                    {{ cohort.name }}
                                    <i v-if="cohort.isEditable" @click="editCohortField(cohort)" class="fas fa-edit ml-2 text-warning" role="button"></i>
                                </td>
                                <td>
                                  <div v-if="cohort.status === 4">
                                    <ul class="list-unstyled m-0">
                                      <li v-if="cohort.total_eids != null">
                                        <strong>Total EIDs:</strong> {{ new Intl.NumberFormat().format(cohort.total_eids) }}
                                      </li>
                                      <li v-if="cohort.total_ips != null">
                                        <strong>Total IPs:</strong> {{ new Intl.NumberFormat().format(cohort.total_ips) }}
                                      </li>
                                      <li v-if="cohort.total_hems != null">
                                        <strong>Total HEMs:</strong> {{ new Intl.NumberFormat().format(cohort.total_hems) }}
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                                <td>
                                  <v-progress-linear
                                      v-if="cohort.status === 4"
                                      color="success"
                                      height="10"
                                      value="100"
                                      rounded
                                  ></v-progress-linear>

                                  <v-progress-linear
                                      v-else-if="cohort.status > 4"
                                      color="error"
                                      height="10"
                                      value="100"
                                      rounded
                                  ></v-progress-linear>

                                  <v-progress-linear
                                      v-else
                                      color="#fb7e42"
                                      height="10"
                                      indeterminate
                                      rounded
                                  ></v-progress-linear>

                                  <span class="mt-1 d-block">{{ cohort.status_string }}</span>
                                </td>
                                <td>
                                    <div v-if="cohort.identifier"><strong>Base Identifier: </strong>{{ cohort.identifier }}</div>
                                    <div v-if="cohort.details">
                                        <ul class="list-unstyled mb-0">
                                            <li v-if="cohort.details.type === 'campaign'"><strong>Campaign: </strong>{{ '#' + cohort.details.data.id + ' - ' + cohort.details.data.name }}</li>
                                            <li v-if="cohort.details.type === 'campaign'"><strong>Recency: </strong>{{ cohort.details.data.start_date + ' - ' + cohort.details.data.end_date }}</li>
                                            <li v-if="cohort.details.type === 'audience'"><strong>Audience: </strong>{{ '#' + cohort.details.data.id + ' - ' + cohort.details.data.name }}</li>
                                        </ul>
                                    </div>
                                    <div v-if="cohort.limits">
                                        <ul class="list-unstyled mb-0">
                                            <li><strong>Limit: </strong>
                                                <span v-if="cohort.limits.type === 'devices'">
                                                  <i v-if="cohort.limits.limit === 0 || cohort.limits.limit === null">No Limit</i>
                                                  <template v-else>
                                                    {{ new Intl.NumberFormat().format(cohort.limits.limit) }} Devices
                                                  </template>
                                                </span>
                                                <span v-if="cohort.limits.type === 'distance'">{{ new Intl.NumberFormat().format(cohort.limits.distance) }} {{ cohort.limits.unit }}</span>
                                                <span v-if="cohort.limits.type === 'frequency'">
                                                    <span v-if="cohort.limits.is_day_part">DayPart </span>
                                                    <span v-else>Daily </span>
                                                    <span>Freq. of {{ cohort.limits.min + ' - ' + cohort.limits.max }}</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="cohort.details && cohort.details.type === 'campaign' && cohort.details.data.parameters && cohort.details.data.parameters.length">
                                        <ul class="list-unstyled mb-0 mt-1">
                                            <li><strong>Campaign Parameters: </strong></li>
                                            <li class="ml-2" v-if="cohort.details.type === 'campaign' && cohort.details.data.parameters && cohort.details.data.parameters.length" v-for="parameter in cohort.details.data.parameters">
                                                <strong>{{ parameter.key }}: </strong>{{ parameter.value }}
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                                <td>
                                    <span class="d-block">{{ cohort.created_by }}</span>
                                </td>
                                <td>{{ cohort.updated_at }}</td>
                                <td>{{ cohort.created_at }}</td>
                                <td>
                                    <v-tooltip top color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <button
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="showDeleteModal(cohort)"
                                                class="btn btn-danger btn-sm">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </template>
                                        <span>Delete Cohort</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <v-pagination
                        color="#ff7516"
                        v-if="totalPages > 1"
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="7"
                    ></v-pagination>

                    </div>
                </v-app>
            </template>
        </Main>
        <DeleteModal v-if="deleteModalDialog"></DeleteModal>
        <CreateNewCohortByFile v-if="showNewCohortDialog" :audience="audience"></CreateNewCohortByFile>
        <CohortActions v-if="showCohortActionsDialog"></CohortActions>
    </div>
</template>

<script>
import Main from '../../components/Main'
import api from "../../api/analyses/activations";
import CreateNewPrivateAudience from "../../components/analyses/CreateNewPrivateAudience";
import DeleteModal from "../../components/general/DeleteModal";
import ShowAudienceItem from "../../components/analyses/ShowAudienceItem";
import ActivateAudienceItem from "../../components/analyses/ActivateAudienceItem";
import mixins from "../../mixin"
import TableLoading from "../../components/general/TableLoading";
import CreateNewScheduler from "../../components/analyses/CreateNewScheduler";
import CohortsManagement from "../../components/analyses/CohortsManagementLegacy.vue";
import CreateNewCohortByFile from "../../components/analyses/CreateNewCohortByFile.vue";
import CohortActions from "../../components/analyses/CohortActions.vue";

export default {
    name: "CohortManagement",
    mixins: [mixins],
    data: () => ({
        filter: false,
        currentPage: 1,
        totalPages: 1,
        editing_cohort: {
            id: '',
            name: '',
        },
        searchData: {
            q: '',
            sortBy: 'created_at',
            orderBy: 'desc',
            itemsPerPage: 25,
            loading: false,
        },
        sorts: [
            {
                value: 'name',
                text: 'Name'
            },
            {
                value: 'status',
                text: 'Status'
            },
            {
                value: 'created_at',
                text: 'Last Created'
            },
            {
                value: 'updated_at',
                text: 'Last Updated'
            },
        ],

        loading: true,
        audience: [],
        deleteModalDialog: false,
        cohorts: [],
        deletingCohort: [],
        showNewCohortDialog: false,
        showCohortActionsDialog: false,
    }),
    components: {
        CohortActions,
        CreateNewCohortByFile,
        TableLoading,
        Main,
        DeleteModal
    },
    methods: {
        async fetchData() {
            this.loading = true
            await api.getAllCohorts({
                page: this.currentPage,
                total: this.searchData.itemsPerPage,
                q: this.searchData.q,
                sortBy: this.searchData.sortBy,
                orderBy: this.searchData.orderBy,
                createdBy: this.searchData.createdBy
            })
            .then(res => {
                this.cohorts = res.data.data
                this.currentPage = res.data.pagination.current_page
                this.totalPages = res.data.pagination.last_page
                this.scrollToTop()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
            })
            this.loading = false
        },
        showDeleteModal(cohort) {
            this.deletingCohort = cohort
            this.deleteModalDialog = true
        },
        showNewCohortModal() {
            this.showNewCohortDialog = true
        },
        showCohortActionsModal() {
            this.showCohortActionsDialog = true
        },
        editCohortField(cohort) {
            this.editing_cohort.id = cohort.id
            this.editing_cohort.name = cohort.name
        },
        updateCohortName(name) {
            if (this.editing_cohort.name === name) {
                this.editing_cohort.id = ''
                this.editing_cohort.name = ''
            } else {
                this.updateItem()
            }
        },
        createNewCohort() {
            this.showNewCohortModal()
        },
        cohortActions() {
            this.showCohortActionsModal()
        },
        cancelUpdateCohortName() {
            this.editing_cohort.id = ''
            this.editing_cohort.name = ''
        },
        async updateItem() {
            await api.updateCohortName({
                id: this.editing_cohort.id,
                name: this.editing_cohort.name
            })
                .then(res => {
                    this.editing_cohort.id = ''
                    this.editing_cohort.name = ''
                    this.fetchData()
                    this.$toast.open({
                        message: 'Cohort has been successfully updated',
                        type: "success",
                    })
                })
                .catch(e => {
                    this.editing_cohort.id = ''
                    this.editing_cohort.name = ''
                    this.$toast.open({
                        message: e.response.data.message,
                        type: "error",
                    })
                })
        },
        async deleteItem() {
            await api.deleteCohort({
                cohort: this.deletingCohort.id,
            })
                .then(res => {
                    this.deleteModalDialog = false
                    this.deletingCohort = []
                    this.fetchData()
                    this.$toast.open({
                        message: res.data.message,
                        type: "success",
                    })
                    this.scrollToTop()
                })
                .catch(e => {
                    this.$toast.open({
                        message: e.response.message,
                        type: "error",
                    })
                    this.deleteModalDialog = false
                    this.deletingCohort = []
                    this.scrollToTop()
                })
        },
        filterData: _.debounce(function() {
            this.fetchData()
            this.searchData.loading = false
        }, 800),
    },
    created() {
        this.fetchData()
    },
    computed: {
        //
    },
    watch: {
        '$store.getters.getCompanyId' : function (val) {
            if (val !== null) {
                window.Echo.private('cohorts-' + this.$store.getters.getCompanyId)
                    .listen('Backend\\Cohorts\\FileCohortUpdated', (e) => {
                        this.fetchData()
                    })
            }
        },
        currentPage: function () {
            this.fetchData()
        },
        'searchData.q': function () {
            if (this.searchData.q == null) {
                this.searchData.q = ""
            }
            this.filterData()
        },
        'searchData.sortBy': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.orderBy': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.itemsPerPage': function () {
            this.searchData.loading = true
            this.filterData()
        }
    },
    mounted() {
        //
    }
}
</script>

<style scoped lang="scss">
::v-deep .v-application--wrap {
    min-height: fit-content;
}

button:focus {
    outline:0;
}
</style>